import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Title from 'shared/components/title/Title';
import IngredientContent from './IngredientContent';

const AddIngredient = props => {
  const {
    handleReturnToInitialStep,
    handleSelectIngredient,
    handleCreateNewFood,
    headerTitle,
    nutritionPlan
  } = props;

  return (
    <div className="add-ingredient">
      <div className="container">
        <Breadcrumb>
          <Breadcrumb.Item href="/nutrition">Nutrition</Breadcrumb.Item>
          <Breadcrumb.Item href={`/nutrition/${nutritionPlan.id}`}>
            {nutritionPlan.name}
          </Breadcrumb.Item>
          <Breadcrumb.Item onClick={handleReturnToInitialStep}>
            {headerTitle}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Add Ingredient</Breadcrumb.Item>
        </Breadcrumb>
        <Title
          pageTitle="Add Ingredient"
          linkText="Cancel"
          cancelBtn={handleReturnToInitialStep}
        />
        <IngredientContent
          handleSelectIngredient={handleSelectIngredient}
          handleCreateNewFood={handleCreateNewFood}
        />
      </div>
    </div>
  );
};

export default AddIngredient;
